export default "__VITE_ASSET__289cfb92__"